(() => {
  if (window.tclLwpMedia) {
    window.tclLwpMedia.init();
    return;
  }

  function hydrateLwpTemplates(root, selector) {
    root.querySelectorAll(selector).forEach((template) => {
      template.replaceWith(template.content.cloneNode(true));
    });
  }

if (!customElements.get('live-with-povison')) {
  customElements.define(
    'live-with-povison',
    class LiveWithPovison extends HTMLElement {
      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';
        if (!this.enableSlider) return;

        this.slider = this.querySelector('.swiper');
        if (!this.slider) return;

        this.handleChange = this.init.bind(this);
        this.mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);

        if (this.mql.addEventListener) {
          this.mql.addEventListener('change', this.handleChange);
        } else {
          this.mql.onchange = this.handleChange;
        }

        this.init();
      }

      disconnectedCallback() {
        if (this.mql) {
          if (this.mql.removeEventListener) {
            this.mql.removeEventListener('change', this.handleChange);
          } else {
            this.mql.onchange = null;
          }
        }

        this.destroySlider();
      }

      init() {
        this.destroySlider();
        this.initSlider();
      }

      initSlider() {
        const section = this.closest('.section--live-with-povison');
        const gapDesktop = Number(this.dataset.gap) || 18;
        const gapMobile = Number(this.dataset.gapMobile) || gapDesktop;
        const gap = (this.mql && this.mql.matches) ? gapMobile : gapDesktop;
        const slidesDesktop = Number(this.dataset.slidesDesktop) || 5;
        const slidesTablet = Number(this.dataset.slidesTablet) || 3;
        const slidesMobile = Number(this.dataset.slidesMobile) || 2;

        this.sliderInstance = new window.FoxTheme.Carousel(this.slider, {
          slidesPerView: slidesMobile,
          spaceBetween: gap,
          breakpoints: {
            768: {
              slidesPerView: slidesTablet,
              spaceBetween: gap,
            },
            1024: {
              slidesPerView: slidesDesktop,
              spaceBetween: gap,
            },
          },
          navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
          },
          threshold: 2,
          watchOverflow: true,
          grabCursor: true,
        });

        this.sliderInstance.init();
      }

      destroySlider() {
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}

// ─── Live With Povison Modal ────────────────────────────────────────────────
class LwpMediaHelper {
_pauseMediaItem(item) {
    const video = item.querySelector('video');
    if (video) video.pause();

    const iframe = item.querySelector('iframe');
    if (iframe && iframe.getAttribute('src')) {
      iframe.dataset.src = iframe.getAttribute('src');
      iframe.src = '';
    }
  }

_resumeMediaItem(item) {
    hydrateLwpTemplates(item, 'template[data-lwp-image]');
    if (item.dataset.mediaType === 'video') {
      const wrap = item.querySelector('.lwp-modal__video-wrap');
      if (!wrap) return;
      hydrateLwpTemplates(wrap, 'template[data-lwp-video]');

      if (!wrap.dataset.videoInited) {
        this._initVideo(wrap);
        wrap.dataset.videoInited = 'true';
      }

      const iframe = item.querySelector('iframe');
      if (iframe && !iframe.getAttribute('src') && iframe.dataset.src) {
        iframe.src = iframe.dataset.src;
      }

      const video = item.querySelector('video');
      if (video) {
        video.play().catch(() => { });
      }
    }
  }

_initVideo(wrap) {
    const url = wrap.dataset.videoUrl;
    if (!url) return;

    let el;

    if (/youtube\.com|youtu\.be/.test(url)) {
      const id = this._getYouTubeId(url);
      if (!id) return;
      el = document.createElement('iframe');
      el.src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&rel=0`;
      el.allow = 'autoplay; encrypted-media; fullscreen';
      el.allowFullscreen = true;
      el.className = 'lwp-modal__iframe';
    } else if (/tiktok\.com/.test(url)) {
      const id = this._getTikTokId(url);
      if (!id) return;
      el = document.createElement('iframe');
      el.src = `https://www.tiktok.com/player/v1/${id}?autoplay=1`;
      el.allow = 'autoplay; fullscreen';
      el.allowFullscreen = true;
      el.className = 'lwp-modal__iframe';
    } else {
      // direct video (mp4, webm, etc.)
      el = document.createElement('video');
      el.src = url;
      el.autoplay = true;
      el.muted = true;
      el.loop = true;
      el.playsInline = true;
      el.className = 'lwp-modal__video';

      // mute toggle button
      const muteBtn = document.createElement('button');
      muteBtn.type = 'button';
      muteBtn.className = 'lwp-modal__mute-btn is-muted';
      muteBtn.setAttribute('aria-label', 'Toggle mute');
      muteBtn.innerHTML = this._mutedIcon();
      muteBtn.addEventListener('click', () => {
        el.muted = !el.muted;
        muteBtn.classList.toggle('is-muted', el.muted);
        muteBtn.innerHTML = el.muted ? this._mutedIcon() : this._unmutedIcon();
      });
      wrap.appendChild(muteBtn);
    }

    if (el) wrap.prepend(el);
  }

_mutedIcon() {
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
  }

_unmutedIcon() {
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"/></svg>';
  }

_getYouTubeId(url) {
    const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([^&\n?#]+)/);
    return m ? m[1] : null;
  }

_getTikTokId(url) {
    const m = url.match(/tiktok\.com\/@[^/]+\/video\/(\d+)/);
    return m ? m[1] : null;
  }
}

function initLwpProductPopupMedia() {
  const mediaHelper = Object.create(LwpMediaHelper.prototype);
  const sliderStates = new WeakMap();
  const dialogs = new Map();
  const selector = 'modal-dialog.product-popup-modal[data-lwp-section]';

  const hydrateImages = (dialog) => hydrateLwpTemplates(dialog, 'template[data-lwp-image]');
  const pauseDialog = (dialog) => {
    dialog.querySelectorAll('[data-media-item]').forEach((item) => mediaHelper._pauseMediaItem(item));
  };

  const ensureState = (slider) => {
    let state = sliderStates.get(slider);
    if (state) return state;
    const mediaItems = Array.from(slider.querySelectorAll('[data-media-item]'));
    const activeIndex = mediaItems.findIndex((item) => item.classList.contains('is-active'));
    state = {
      slider,
      contentEl: slider.closest('.product-popup-modal__content') || slider,
      mediaItems,
      mediaIndex: activeIndex >= 0 ? activeIndex : 0,
      mediaList: slider.querySelector('.lwp-modal__media-list'),
    };
    sliderStates.set(slider, state);
    return state;
  };

  const setActiveMedia = (state, nextIndex, { immediate = false } = {}) => {
    if (!state.mediaItems.length) return;
    const total = state.mediaItems.length;
    const normalized = (nextIndex % total + total) % total;
    const currentItem = state.mediaItems[state.mediaIndex];
    const nextItem = state.mediaItems[normalized];
    if (!immediate && currentItem && currentItem !== nextItem) mediaHelper._pauseMediaItem(currentItem);
    state.mediaItems.forEach((item, index) => {
      const active = index === normalized;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    state.slider.querySelectorAll('[data-media-to]').forEach((dot, index) => {
      dot.classList.toggle('is-active', index === normalized);
      dot.setAttribute('aria-current', index === normalized ? 'true' : 'false');
    });
    state.mediaIndex = normalized;
    if (state.mediaList) {
      const leftColumn = state.contentEl.querySelector('.lwp-modal__left');
      const fallbackWidth = leftColumn ? leftColumn.getBoundingClientRect().width : 0;
      const itemWidth = state.mediaItems[0].getBoundingClientRect().width || fallbackWidth;
      state.mediaList.style.transform = `translate3d(${normalized * itemWidth * -1}px,0,0)`;
    }
    mediaHelper._resumeMediaItem(nextItem);
  };

  const setMetaExpanded = (toggle, expanded) => {
    const metaId = toggle.getAttribute('aria-controls');
    const metaWrap = toggle.closest('.lwp-modal__meta-wrap');
    const meta = metaId ? document.getElementById(metaId) : metaWrap?.querySelector('.lwp-modal__meta');
    if (!meta) return;
    meta.classList.toggle('is-expanded', expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? 'Show Less' : 'Show More';
  };

  const registerDialog = (dialog) => {
    if (dialogs.has(dialog)) return;
    const entry = { frame: null, observer: null };
    const syncOpenState = () => {
      window.cancelAnimationFrame(entry.frame);
      entry.frame = null;
      if (!dialog.hasAttribute('open')) {
        pauseDialog(dialog);
        return;
      }
      hydrateImages(dialog);
      dialog.querySelectorAll('.lwp-modal__meta-toggle').forEach((toggle) => setMetaExpanded(toggle, false));
      // Dawn pauses all media synchronously in show(); resume after that work.
      entry.frame = window.requestAnimationFrame(() => {
        entry.frame = null;
        if (!dialog.isConnected || !dialog.hasAttribute('open')) return;
        const slider = dialog.querySelector('[data-media-slider]');
        if (!slider) return;
        const state = ensureState(slider);
        setActiveMedia(state, state.mediaIndex, { immediate: true });
      });
    };
    entry.observer = new MutationObserver(syncOpenState);
    entry.observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    dialogs.set(dialog, entry);
    if (dialog.hasAttribute('open')) syncOpenState();
  };

  const releaseDialog = (dialog, entry) => {
    entry.observer.disconnect();
    window.cancelAnimationFrame(entry.frame);
    pauseDialog(dialog);
    const slider = dialog.querySelector('[data-media-slider]');
    if (slider) sliderStates.delete(slider);
    dialogs.delete(dialog);
  };

  const init = () => {
    dialogs.forEach((entry, dialog) => {
      if (!dialog.isConnected) releaseDialog(dialog, entry);
    });
    // Support uploading this asset before the matching section markup.
    document.querySelectorAll('.section--live-with-povison modal-opener[data-modal]').forEach((opener) => {
      const modalSelector = opener.getAttribute('data-modal');
      if (!modalSelector?.startsWith('#')) return;
      const dialog = document.getElementById(modalSelector.slice(1));
      const section = opener.closest('.shopify-section');
      if (dialog?.matches('modal-dialog.product-popup-modal') && section && !dialog.dataset.lwpSection) {
        dialog.dataset.lwpSection = section.id.replace('shopify-section-', '');
      }
    });
    // Dawn moves dialogs to body, so a scan confined to the section misses them.
    document.querySelectorAll(selector).forEach(registerDialog);
  };

  const warmDialogImages = (event) => {
    const opener = event.target.closest('modal-opener[data-modal]');
    if (!opener || !opener.closest('.section--live-with-povison')) return;
    const modalSelector = opener.getAttribute('data-modal');
    if (!modalSelector?.startsWith('#')) return;
    const dialogId = modalSelector.slice(1);
    let dialog = document.getElementById(dialogId);
    if (!dialog) {
      const section = opener.closest('.shopify-section');
      const template = Array.from(section.querySelectorAll('template[data-lwp-dialog]'))
        .find((item) => item.dataset.lwpDialog === dialogId);
      if (!template) return;
      // Insert within the section first: Dawn reads its section id before moving
      // the dialog to body. The capture listener runs before ModalOpener.show().
      template.replaceWith(template.content.cloneNode(true));
      dialog = document.getElementById(dialogId);
    }
    if (!dialog?.matches(selector)) return;
    registerDialog(dialog);
    hydrateImages(dialog);
  };
  document.addEventListener('pointerover', warmDialogImages, { passive: true });
  document.addEventListener('focusin', warmDialogImages);
  document.addEventListener('pointerdown', warmDialogImages, { passive: true, capture: true });
  document.addEventListener('click', warmDialogImages, { capture: true });

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-media-prev], [data-media-next], [data-media-to]');
    const dialog = control?.closest(selector);
    if (!dialog?.hasAttribute('open')) return;
    const slider = control.closest('[data-media-slider]');
    if (!slider) return;
    event.preventDefault();
    event.stopPropagation();
    const state = ensureState(slider);
    if (control.hasAttribute('data-media-prev')) setActiveMedia(state, state.mediaIndex - 1);
    else if (control.hasAttribute('data-media-next')) setActiveMedia(state, state.mediaIndex + 1);
    else {
      const targetIndex = Number(control.dataset.mediaTo);
      if (Number.isInteger(targetIndex)) setActiveMedia(state, targetIndex);
    }
  });

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.lwp-modal__meta-toggle');
    if (!toggle?.closest(selector)) return;
    event.preventDefault();
    setMetaExpanded(toggle, toggle.getAttribute('aria-expanded') !== 'true');
  });
  document.addEventListener('modalClosed', () => {
    dialogs.forEach((entry, dialog) => pauseDialog(dialog));
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', (event) => {
    if (!event.detail?.blockId) return;
    const section = event.target.closest('.section--live-with-povison');
    if (!section) return;
    const opener = Array.from(section.querySelectorAll('modal-opener[data-modal]'))
      .find((item) => item.getAttribute('data-modal') === `#PopupModal-${event.detail.blockId}`);
    const button = opener?.querySelector('button');
    if (!button) return;
    warmDialogImages({ target: button });
    const dialog = document.getElementById(`PopupModal-${event.detail.blockId}`);
    if (dialog && !dialog.hasAttribute('open')) dialog.show(button);
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    if (!event.detail?.blockId) return;
    const dialog = document.getElementById(`PopupModal-${event.detail.blockId}`);
    if (dialog?.matches(selector) && dialog.hasAttribute('open')) dialog.hide();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    dialogs.forEach((entry, dialog) => {
      if (dialog.dataset.lwpSection !== event.detail.sectionId) return;
      releaseDialog(dialog, entry);
      if (dialog.hasAttribute('open') && typeof dialog.hide === 'function') dialog.hide();
      // Match Dawn's editor cleanup for dialogs moved outside their section.
      dialog.remove();
    });
  });

  window.tclLwpMedia = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}

initLwpProductPopupMedia();



})();
